/* eslint-disable react/prop-types */
import React, {forwardRef, Fragment} from "react";
import {ControlRef, ControlProps} from "../types";
import {controlCSS} from "../styles/control";

const Control = forwardRef<ControlRef, ControlProps>(
  (
    {
      bemBuilder,
      getOptionLabel,
      getStyles,
      menuIsOpen,
      onClick,
      onKeyDown,
      placeholder,
      crossBrand,
      disabled,
      focus,
      hasError,
      inverse,
      value,
      ariaLabelledBy,
      id,
      enabledFeatures,
    },
    ref
  ) => {
    const hasValue = value !== undefined;
    const ariaLabelledByWithId = ariaLabelledBy
      ? `${ariaLabelledBy} ${id}`
      : id;
    return (
      <Fragment>
        <button
          ref={ref}
          aria-expanded={menuIsOpen}
          aria-haspopup="listbox"
          aria-labelledby={ariaLabelledByWithId}
          className={bemBuilder("control")}
          css={(theme) =>
            getStyles(
              "Control",
              controlCSS({
                theme,
                crossBrand,
                disabled,
                focus,
                hasError,
                inverse,
                enabledFeatures,
              }),
              {
                theme,
                crossBrand,
                disabled,
                focus,
                hasError,
                inverse,
              }
            )
          }
          data-toggle
          disabled={disabled}
          id={id}
          onClick={onClick}
          onKeyDown={onKeyDown}
          onKeyUp={(e) => e.preventDefault()} // Prevent click event from emitting in Firefox
          type="button"
        >
          {hasValue ? getOptionLabel(value) : placeholder}
        </button>
      </Fragment>
    );
  }
);

Control.displayName = "Control";

export default Control;
